// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import ElementUI from 'element-ui';
import VueCodemirror from 'vue-codemirror';
import VueClipboard from 'vue-clipboard2';
import VueQrCode from '@xkeshi/vue-qrcode';
import VueQuillEditor from 'vue-quill-editor';
import VueBarcode from 'vue-barcode';
import VueAMap from 'vue-amap';
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';
import 'animate.css';
import 'element-ui/lib/theme-chalk/index.css';
import 'codemirror/lib/codemirror.css';
import 'Assets/scss/reset.scss';
import 'Assets/scss/global.scss';
import 'Assets/scss/_mixins.scss';
import 'Assets/scss/_variables.scss';
import 'Assets/scss/_functions.scss';
import 'Assets/iconfont/iconfont.css';
import Plugin from 'Utils/plugin';
import Print from 'Utils/print'; // 引入打印的js文件
import interceptors from 'Api/interceptors';
import Request from 'Api/request';
import router from './router';
import store from './store';
import App from './App';
import directive from './directive';

Vue.use(ElementUI);
Vue.use(Plugin);
Vue.use(directive);
Vue.use(Print);
Vue.use(VueQuillEditor);
Vue.use(VueCodemirror);
Vue.use(VueClipboard);
Vue.use(VueAMap);
Vue.component('qrcode', VueQrCode);
Vue.component('barcode', VueBarcode);
Vue.config.productionTip = false;
global.Request = Request;

// 地图开始
VueAMap.initAMapApiLoader({
  key: '4c2976f939d5f9108c536bdb864f609e',
  plugin: [
    'AMap.Scale',
    'AMap.OverView',
    'AMap.ToolBar',
    'AMap.MapType',
    'AMap.PlaceSearch',
    'AMap.Geolocation',
    'AMap.Geocoder',
    'AMap.DistrictSearch',
    'AMap.Marker',
    'AMap.MarkerClusterer',
    'AMap.MouseTool',
    'AMap.MoveAnimation',
  ],
  v: '2.0',
  uiVersion: '1.1.1' });
// 地图结束

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  interceptors,
  template: '<App/>',
  components: { App },
});



// WEBPACK FOOTER //
// ./src/main.js